import { Injectable } from '@angular/core';
import { ToastrService, IndividualConfig, ActiveToast } from 'ngx-toastr';
import { MessageService } from './message.abstract.service';

@Injectable({
    providedIn: 'root',
})
export class MessageImplService implements MessageService {
    constructor(private toastr: ToastrService) {}

    info(message: string, title?: string, options?: Partial<IndividualConfig>): void {
        this.toastr.info(message, title, options);
    }

    success(message: string, title?: string, options?: Partial<IndividualConfig>): void {
        this.toastr.success(message, title, options);
    }

    warning(message: string, title?: string, options?: Partial<IndividualConfig>): void {
        this.toastr.warning(message, title, options);
    }

    error(message: string, title?: string, options?: Partial<IndividualConfig>): void {
        this.toastr.error(message, title, options);
    }

    /**
     * Show an info toast and return the ActiveToast reference for click handling
     * Use toast.onTap.subscribe() to handle clicks
     */
    infoClickable(message: string, title?: string, options?: Partial<IndividualConfig>): ActiveToast<unknown> {
        return this.toastr.info(message, title, {
            ...options,
            tapToDismiss: false, // Don't dismiss on tap, let the handler decide
            timeOut: 30000, // Keep visible for 30 seconds for user to click
        });
    }
}

export const MESSAGE_SERVICE_PROVIDER = {
    provide: MessageService,
    useClass: MessageImplService,
};
